import React from "react";
import { classNames } from "src/helpers/classNames";

export function CircularProgress({ variant = "progress", value = 0, size = 40, stroke = 3, color = "text-highlightColor", trackColor = "#e5e7eb", spinnerArc = 0.2, className, children }) {
  const r = (size - stroke) / 2;
  const C = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, value));
  const offset = C - (clamped / 100) * C;
  const arcLen = Math.max(0.05, Math.min(0.95, spinnerArc)) * C;
  const isSpinner = variant === "spinner";

  return (
    <div
      className={classNames("relative inline-flex", className)}
      style={{ width: size, height: size }}
      role="progressbar"
      aria-valuemin={isSpinner ? undefined : 0}
      aria-valuemax={isSpinner ? undefined : 100}
      aria-valuenow={isSpinner ? undefined : clamped}
      aria-busy={isSpinner ? true : undefined}>
      <svg
        width={size}
        height={size}
        className={classNames("absolute left-0 top-0 z-0 rotate-[-90deg]", color)}
        viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={trackColor}
          strokeWidth={stroke}
          fill="none"
        />
        {isSpinner ? (
          <g className="origin-center animate-spin">
            <circle
              cx={size / 2}
              cy={size / 2}
              r={r}
              stroke="currentColor"
              strokeWidth={stroke}
              fill="none"
              strokeLinecap="round"
              strokeDasharray={`${arcLen} ${C}`}
              strokeDashoffset={0}
            />
          </g>
        ) : (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            stroke="currentColor"
            strokeWidth={stroke}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={C}
            strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 120ms linear" }}
          />
        )}
      </svg>
      <div className="relative z-10 flex h-full w-full items-center justify-center text-xs font-semibold text-gray-700">{isSpinner ? children ?? null : children ?? <span>{Math.round(clamped)}%</span>}</div>
    </div>
  );
}
